import React from 'react';
import { RegionalMapContainer } from './RegionalMap';
import { RegionalDataContainer } from './RegionalData';
import { SectionWrapper } from '../Investigate.styles';
import { Title, Header, ButtonWrapper } from './RegionalSection.styles';
import {
	ApSimpleDropdown,
	ApMenu,
	ApMenuItem,
	ApButtonIcon,
} from '@alixpartners/ui-components';
import { EXPORT_OPTIONS } from '../utils';
import isEqual from 'lodash/isEqual';
import {
	getInvestigateRegionalMapDataExport,
	exportInvestigateRegionsData,
} from 'utils/apiRequests';
import { STATES_MAP_CODES } from './utils';

const DIMENSION_OPTIONS = [
	{
		label: 'Purchasing location',
		value: 'purchasing',
	},
	{
		label: 'Receiving location',
		value: 'receiving',
	},
];

export class RegionalSection extends React.Component {
	state = {
		selectedCountry: null,
		selectedState: null,
		dimension: DIMENSION_OPTIONS[0],
	};

	chartRef = React.createRef();

	componentDidUpdate(prevProps, prevState) {
		const { queryParams } = this.props;
		const { dimension } = this.state;

		if (
			!isEqual(queryParams, prevProps.queryParams) ||
			dimension.value !== prevState.dimension.value
		) {
			this.setState({
				selectedCountry: null,
				selectedState: null,
			});
		}
	}

	selectCountry = (countryName, callback) => {
		const { selectedCountry } = this.state;
		const value = selectedCountry === countryName ? null : countryName;

		this.setState({ selectedCountry: value }, callback);
	};

	selectState = (name, callback) => {
		const { selectedState } = this.state;
		const value = selectedState === name ? null : name;

		this.setState({ selectedState: value }, callback);
	};

	getChartInstance = () => {
		return (
			this.chartRef && this.chartRef.current && this.chartRef.current.chart
		);
	};

	getMapExportApiParams = () => {
		const { queryParams } = this.props;
		const { dimension, selectedCountry, selectedState } = this.state;
		const isPurchasing = dimension.value === 'purchasing';
		const countryFilter = `${dimension.value}Country`;
		const stateFilter = `${dimension.value}State`;
		const showState = !!STATES_MAP_CODES[selectedCountry];

		return {
			...queryParams,
			filters: [
				...queryParams.filters,
				...(selectedCountry ? [countryFilter] : []),
				...(selectedState ? [stateFilter] : []),
			],
			filterValues: [
				...queryParams.filterValues,
				...(selectedCountry ? [selectedCountry] : []),
				...(selectedState ? [selectedState] : []),
			],
			isPurchasing,
			includeState: showState,
		};
	};

	handleExport = option => {
		const chartInstance = this.getChartInstance();

		if (chartInstance && option.value === 'png') {
			chartInstance.exportChart(
				{
					filename: 'SXR-Regional_spend_overlap',
				},
				{
					chart: { width: 1200 },
				}
			);
		}

		if (option.value === 'xlsx') {
			this.handleMapDataExport();
		}
	};

	handleMapDataExport = () => {
		const { onDownloadStart, onDownloadSuccess, onDownloadError } = this.props;

		onDownloadStart();
		getInvestigateRegionalMapDataExport(this.getMapExportApiParams())
			.catch(onDownloadError)
			.finally(onDownloadSuccess);
	};

	handleTableDataExport = params => {
		const { onDownloadStart, onDownloadSuccess, onDownloadError } = this.props;

		onDownloadStart();
		exportInvestigateRegionsData(params)
			.catch(onDownloadError)
			.finally(onDownloadSuccess);
	};

	handleDimensionChange = option => {
		this.setState({ dimension: option });
	};

	render() {
		const { selectedCountry, selectedState, dimension } = this.state;
		const {
			cardTitle,
			currencySymbol,
			queryParams,
			showExplorePage,
		} = this.props;

		return (
			<SectionWrapper>
				<Header>
					<Title>{cardTitle}</Title>
					<ButtonWrapper>
						<ApSimpleDropdown
							onChange={this.handleDimensionChange}
							options={DIMENSION_OPTIONS}
							selected={dimension}
						/>
					</ButtonWrapper>
					<ApMenu button={<ApButtonIcon iconName="download" />}>
						{EXPORT_OPTIONS.map(option => (
							<ApMenuItem
								key={option.value}
								onClick={() => this.handleExport(option)}
							>
								{option.label}
							</ApMenuItem>
						))}
					</ApMenu>
				</Header>

				<RegionalMapContainer
					chartRef={this.chartRef}
					selectedCountry={selectedCountry}
					selectedState={selectedState}
					onStateSelect={this.selectState}
					onCountrySelect={this.selectCountry}
					currencySymbol={currencySymbol}
					queryParams={queryParams}
					dimension={dimension}
				/>
				<RegionalDataContainer
					selectedCountry={selectedCountry}
					selectedState={selectedState}
					currencySymbol={currencySymbol}
					queryParams={queryParams}
					dimension={dimension}
					onExport={this.handleTableDataExport}
					showExplorePage={showExplorePage}
				/>
			</SectionWrapper>
		);
	}
}

export default RegionalSection;
